module.exports = __webpack_public_path__ + "static/media/clover-mini-pos-device-any-business-large.6173c456.jpg";